import { escapeHtml, fromNow, stamp } from '../inventoree/format'

export { escapeHtml, fromNow, stamp }

const DASH = '<i class="fas fa-minus font-10"></i>'

export function dash(): string {
  return DASH
}

export function textOrDash(value: unknown): string {
  return value ? escapeHtml(value) : DASH
}

/** Convert.FormatSecondsAsDurationString */
export function durationString(seconds: number): string {
  let s = ''
  const days = Math.floor(seconds / 86400)
  if (days >= 1) {
    s += days.toString() + 'day' + (days === 1 ? ' ' : 's ')
    seconds -= days * 86400
  }
  const hours = Math.floor(seconds / 3600)
  if (hours >= 1) {
    s += hours.toString() + 'h '
    seconds -= hours * 3600
  }
  const minutes = Math.floor(seconds / 60)
  if (minutes >= 1) {
    s += minutes.toString() + 'min '
    seconds -= minutes * 60
  }
  if (seconds > 0) s += parseInt(String(seconds), 10).toString() + 's'
  if (s === '') s += '0s'
  return s
}

/** Convert.FormatSecondsAsShortDuration from opteemum.js */
export function shortDuration(seconds: number): string {
  seconds = parseInt(String(seconds), 10)
  if (!seconds || seconds < 0) return '0s'
  const units = [
    { suffix: 'd', size: 86400 },
    { suffix: 'h', size: 3600 },
    { suffix: 'm', size: 60 },
    { suffix: 's', size: 1 },
  ]
  for (let i = 0; i < units.length; i++) {
    const value = Math.floor(seconds / units[i].size)
    if (value <= 0) continue
    let out = value + units[i].suffix
    const rest = seconds - value * units[i].size
    if (i + 1 < units.length) {
      const second = Math.floor(rest / units[i + 1].size)
      if (second > 0) out += ' ' + second + units[i + 1].suffix
    }
    return out
  }
  return '0s'
}

/** temperatureConvert(value, true) with Celsius (appTemperature F stays in CI). */
export function temperature(value: unknown): string {
  const n = Number(value)
  if (!n) return DASH
  return '<i class="fas fa-thermometer-half"></i> ' + n + '<sup>o</sup>C'
}

export function guard(value: unknown): string {
  if (!value) return DASH
  return Number(value) > 0
    ? '<i class="fas fa-check-circle font-20 color-green2"></i>'
    : '<i class="fas fa-exclamation-circle font-20 color-red"></i>'
}

export function fromNowOrDash(value: unknown, now: Date = new Date()): string {
  const when = stamp(value)
  return when ? fromNow(when, now) : DASH
}
